import React from "react";
import styles from "./Card.module.scss";

const Card = ({ navigate, PATHS }) => {
  return (
    <div className={styles.container}>
      <div className={styles.btn} onClick={() => navigate(PATHS.editProfile)}>
        <p>Edit Profile</p>
      </div>
      <div
        className={styles.btn}
        onClick={() => navigate(PATHS.auth.changePassword)}
      >
        <p>Change Password</p>
      </div>
      <div className={styles.btn} onClick={() => navigate(PATHS.payments)}>
        <p>Payments</p>
      </div>
      <small>Terms & Condition &middot; Privacy policy</small>
    </div>
  );
};

export default Card;
